import React, { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";

const AnimatedCounter = ({ from, to, className, duration = 1, toFixed = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true});

  useEffect(() => {
    const counter = ref.current;

    const controls = animate(from, to, {
      duration: duration,
      onUpdate(value) {
        counter.textContent = value.toFixed(toFixed);
      },
    });

    return () => controls.stop();
  }, [duration, from, to, toFixed, isInView]);

  return <span className={className} ref={ref}></span>;
};

export default AnimatedCounter;
